import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

export default function ModalLinkMobile({
  id,
  createNonInternalStream,
  tabindex,
  title,
  description,
  linkVideoIframe,
  children,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <a
        id={`action-point-${id}`}      
        onClick={() => {
          setShowModal(true);
          createNonInternalStream();
        }}
        title={title}
        tabindex={tabindex}
      >
        {children}
      </a>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        className="break-sizing modal-action-point-mobile"
      >
        <div className="modal-custom">
          <div
            onClick={() => setShowModal(false)}
            className="modal-custom__close"
          >
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div>
          {description && <div className="modal-actionpoint-container" dangerouslySetInnerHTML={{ __html: description }} />}
              {linkVideoIframe && <div className="modal-actionpoint-container" dangerouslySetInnerHTML={{ __html: linkVideoIframe }} />}
       
          </div>
        </div>
      </Modal>
    </>
  );
}
